// extracted by mini-css-extract-plugin
export var attachment = "_n2-a";
export var emailContainer = "_n2-4";
export var emailContentPaddedContainer = "_n2-b";
export var emailHeader = "_n2-6";
export var emailIframe = "_n2-3";
export var emailInfoIcon = "_n2-9";
export var emailShortenedSummary = "_n2-e";
export var infoDropdown = "_n2-0";
export var infoRowBoundedContent = "_n2-d";
export var internal = "_n2-5";
export var merchant = "_n2-8";
export var messageInputContainer = "_n2-h";
export var normal = "_n2-7";
export var replyCard = "_n2-f";
export var subtleButton = "_n2-1";
export var subtleButtonIconContainer = "_n2-2";
export var toggleViewRepliesButton = "_n2-c";
export var wrappingText = "_n2-g";